@import ../../../styles/helpers

.gameCard
    width: 100%
    box-shadow: 0px 0px 60px rgba(25,26,35,0)
    height: auto
    border-radius: 30px
    position: relative
    z-index: 10
    &:hover
        z-index: 20
        transform: scale(1.2)
        box-shadow: 0px 0px 45px rgba(25,26,35,0.8)
    transition: transform 0.15s, box-shadow 0.15s
    cursor: pointer
    +d
        &:hover
            transform: scale(1.05)
    +m
        border-radius: 20px
        width: 60px
        height: 60px !important
        button
            flex: 1
            display: flex
            height: 48px
            width: 135px !important
            margin: auto !important
            flex-grow: 0.4 !important
            margin-right: 15px !important

.gameCard img
    width: 100%
    height: 100%
    border-radius: 30px
    object-fit: cover
    +m
        border-radius: 20px

.title
    font-size: 22px
    margin-top: 10px
    margin-left: 22px
    letter-spacing: 1px
    font-weight: 600
    text-align: left
    color: white
    +m
        margin: auto
        margin-left: 15px
        font-size: 17px

.playbutton
        display: none
        position: relative
        border-radius: 50px
        padding: 10px 16px
        background-color: #FACC27
        color: #EC540B
        box-shadow: 0px 0px 20px rgba(250,204,39,0.18)
        margin: auto
        margin-right: 10px
        font-size: 15px
        font-weight: 900
        line-height: 16px
        +m
            display: flex
